import React from 'react';
import styles from './timestamp-line.module.css';

export function TimestampLine({ children }: { children: React.ReactNode }) {
  return <div className={styles.timestampLine}>{children}</div>;
}
